import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  ViewChild,
  computed,
  inject,
  signal,
} from '@angular/core';
import { PromotionCardComponent } from './components/promotion-card/promotion-card.component';
import SketchComponent from '../home/components/sketch/sketch.component';
import { PreparationScheduleComponent } from './components/preparation-schedule/preparation-schedule.component';
import { GuidePlanComponent } from './components/guide-plan/guide-plan.component';
import { ParticipantFaqComponent } from './components/participant-faq/participant-faq.component';
import { GalleryDto, GalleryService } from '@millionshow/api-client';
import { rxResource } from '@angular/core/rxjs-interop';
import { Icon } from '@millionshow/client-libs';

import { GalleryVideoPlayer } from '@millionshow/client-libs';

@Component({
  selector: 'app-event-page',
  imports: [
    GalleryVideoPlayer,
    CommonModule,
    PromotionCardComponent,
    SketchComponent,
    PreparationScheduleComponent,
    GuidePlanComponent,
    ParticipantFaqComponent,

    Icon,
  ],
  templateUrl: './event.page.html',
  styleUrl: './event.page.css',
})
export default class EventPage {
  selectedTab = signal<'promotion' | 'application' | 'preparation' | 'faq'>(
    'promotion'
  );

  @ViewChild('tabContainer') tabContainerRef!: ElementRef<HTMLDivElement>;

  /** Whether there are more tabs to scroll right */
  hasMoreTabs = signal(true);

  changeTab(tab: 'promotion' | 'application' | 'preparation' | 'faq') {
    this.selectedTab.set(tab);
    setTimeout(() => {
      const container = this.tabContainerRef?.nativeElement;
      if (!container) return;
      const activeBtn = container.querySelector('.tab.active') as HTMLElement;
      if (!activeBtn) return;
      const scrollTarget =
        activeBtn.offsetLeft +
        activeBtn.offsetWidth / 2 -
        container.offsetWidth / 2;
      container.scrollTo({ left: scrollTarget, behavior: 'smooth' });
      setTimeout(() => {
        const atEnd =
          container.scrollLeft + container.clientWidth >=
          container.scrollWidth - 4;
        this.hasMoreTabs.set(!atEnd);
      }, 400);
    }, 0);
  }

  onTabScroll(event: Event) {
    const el = event.target as HTMLElement;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    this.hasMoreTabs.set(!atEnd);
  }

  private readonly galleryService = inject<GalleryService>(GalleryService);

  // VIDEO 타입의 최신 갤러리 데이터 가져오기
  $latestVideo = rxResource({
    stream: () => {
      return this.galleryService.galleryControllerSearchV1({
        pageNo: 1,
        pageSize: 1,
        isExposed: true,
        type: 'VIDEO' as GalleryDto['type'],
        category: 'PROMOTION' as GalleryDto['category'],
        orderBy: 'displayDate',
        align: 'desc',
        sourceType: 'AGRITEX' as const,
      });
    },
  });

  // 최신 비디오 데이터
  latestVideoData = computed(() => {
    const items = this.$latestVideo.value()?.items || [];
    return items.length > 0 ? items[0] : null;
  });

  youtubeEmbedUrl = computed(() => {
    const video = this.latestVideoData();
    if (!video || !video.videoLink) return '';
    return video.videoLink;
  });
}
